"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Unit = void 0;
var i18n_1 = require("../../i18n");
var mithril_1 = require("../../mithril");
var theme_1 = require("../theme");
var CSS = {
    unit: 'c-unit'
};
var Style = (_a = {},
    _a[CSS.unit] = {
        'font-weight': theme_1.DefaultTheme.font.weight.bold,
        'margin-left': theme_1.DefaultTheme.space(1),
        'margin-right': theme_1.DefaultTheme.space(2)
    },
    _a);
(0, theme_1.addStyles)(Style);
exports.Unit = {
    view: function (name) {
        return (0, mithril_1.m)('sup', { className: CSS.unit }, (0, i18n_1.Translate)(name));
    }
};
//# sourceMappingURL=unit.js.map